import { useCannabisData } from "../hooks/useCannabisData";

const EXTRA_TYPES = ["CBD"];

function CategorySelect({ value, onChange }) {
  const { types, loading } = useCannabisData();

  const allTypes = [...new Set([...types, ...EXTRA_TYPES])];

  return (
    <label>
      Type
      <select value={value} onChange={(e) => onChange(e.target.value)} disabled={loading}>
        <option value="">-- Select Type --</option>
        {allTypes.map((t) => (
          <option key={t} value={t}>{t}</option>
        ))}
      </select>
    </label>
  );
}

export default CategorySelect;